/**
 * Extracts the language code from a locale string (e.g., "en-US" → "en")
 */
const extractLanguageCode = (locale: string): string => {
    return locale.split('-')[0];
};

/**
 * Generates a language-aware URL for our main website.
 */
export const getVelasolarisUrl = (path: string, language: string): string => {
    // Remove leading/trailing slashes to prevent double slashes
    const cleanPath = path.replace(/^\/+|\/+$/g, '');

    // Extract language code from locale (e.g., "en-US" → "en")
    const languageCode = extractLanguageCode(language);

    // English pages include /en/ prefix
    if (languageCode === 'en') {
        return `https://www.velasolaris.com/en/${cleanPath}`;
    }

    // German pages use no language prefix
    return `https://www.velasolaris.com/${cleanPath}`;
};
